module.exports = __webpack_public_path__ + "media/IMG_3588.7398c916.mp4";